var _g;
import * as React from "react";
var SvgDownloadColored = function SvgDownloadColored(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BFD107",
    fillRule: "nonzero",
    points: "12.6666667 6 10 6 10 2 6 2 6 6 3.33333333 6 8 10.6666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#262626",
    fillRule: "nonzero",
    points: "3.33333333 12 3.33333333 13.3333333 12.6666667 13.3333333 12.6666667 12"
  })));
};
export default SvgDownloadColored;